import classNames from 'clsx';
import React, { useState } from 'react';
import { Manager } from 'react-popper';

import type { Props as ContentProps } from '@swf/components/Translation/Translation';
import Translation from '@swf/components/Translation/Translation';
import Info from '@swf/core/assets/icons/info.svg';
import { Size } from '@swf/core/enums';
import useScreenSize from '@swf/core/hooks/useScreenSize';

import Tooltip from '../Tooltip/Tooltip';
import TooltipReference from '../Tooltip/TooltipReference';

import styles from './InfoTooltip.scss';

export interface Props {
  content: ContentProps[];
  iconClassName?: string;
  tooltipClassName?: string;
  tooltipContentWrapperClassName?: string;
  arrowClassName?: string;
  tagName?: React.ElementType;
}

const InfoTooltip: React.FC<Props> = ({
  iconClassName,
  tooltipClassName,
  tooltipContentWrapperClassName,
  arrowClassName,
  content,
  tagName = 'p'
}) => {
  const [show, setShow] = useState(false);
  const { greaterThan } = useScreenSize();

  const close = () => {
    setShow(false);
  };

  const toggle = () => {
    setShow(!show);
  };

  // TODO: refactor with `usePopper`
  return (
    <Manager>
      <TooltipReference onToggle={toggle}>
        <span className={classNames(styles.info, { [styles.show]: show }, iconClassName)}>
          <Info className={styles.infoIcon} />
        </span>
      </TooltipReference>
      <Tooltip
        isOpen={show}
        createPortal={false}
        onClose={close}
        modifiers={[
          {
            name: 'flip',
            options: {
              fallbackPlacements: ['top', 'bottom']
            }
          },
          {
            name: 'offset',
            options: {
              offset: [-120, greaterThan(Size.Small) ? 15 : 5]
            }
          }
        ]}
      >
        {({ ref, style, placement, arrowProps }) => (
          <div
            className={classNames(styles.tooltip, tooltipClassName)}
            ref={ref}
            style={style}
            data-popper-placement={placement}
          >
            <div className={tooltipContentWrapperClassName}>
              {content.map((tip, i) => (
                <>
                  <Translation key={i} tagName={tagName} {...tip} />{' '}
                </>
              ))}
            </div>
            <div
              className={classNames(styles.tooltipArrow, arrowClassName)}
              ref={arrowProps.ref}
              style={arrowProps.style}
            />
          </div>
        )}
      </Tooltip>
    </Manager>
  );
};

export default InfoTooltip;
